module.exports = __webpack_public_path__ + "img/822e242.png";